import {GET_OTP_REQUESTED} from "resources/actionTypes";

export function getOtp(userOtp, navigate, otpActions) {
  const data ={
    userOtp:userOtp,
    navigate:navigate,
    otpActions: otpActions
  }
  return {
    type: GET_OTP_REQUESTED,
    payload: data,
  };
}